import { Installed } from '../Installed';
import { jsx as _jsx } from "react/jsx-runtime";
export const getNoStatusesOptions = ({
  showInstalledStatus
}) => {
  const content = showInstalledStatus ? /*#__PURE__*/_jsx(Installed, {}) : null;
  return {
    content,
    ctaButton: null,
    tooltipDisabled: true,
    tooltipHeadingText: '',
    tooltipMessage: ''
  };
};